export default {
  SET_TOKEN (state, token) {
    state.token = token
  },
  SET_REFRESH_TOKEN (state, refreshToken) {
    state.refreshToken = refreshToken
  },
  SET_ROLES (state, roles) {
    state.roles = roles
  },
  SET_INIT (state, status) {
    state.init = status
  },
  CLEAR_TOKEN (state) {
    state.token = null
  },
  SET_AUTH (state, auth) {
    state.token = auth.token
    state.refreshToken = auth.refreshToken
  },
  SET_REGISTRATION_TOKEN (state, token) {
    state.registrationToken = token
  },
  SET_REGISTRATION_STEP (state, step) {
    state.registrationStep = step
  },
  CLEAR_REGISTRATION (state) {
    state.registrationToken = null
    state.registrationStep = 1
  },
  CLEAR_AUTH (state) {
    state.token = null
    state.refreshToken = null
    state.roles = ['guest']
  },
  CLEAR_ALL_AUTH (state) {
    state.registrationToken = null
    state.registrationStep = 1
    state.token = null
    state.refreshToken = null
    state.roles = ['guest']
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/mutations.js